export const productExtraOptionTypesEnum = {
    textFill: "Agregar comentario",
    fileLoad: "Carga de archivo",
    imageLoad: "Carga de imagen",
    textChoice: "Seleccionar una opción",
    imageChoice: "Seleccionar una imagen",
    multiTextChoice: "Seleccionar muchas opciones"
};
